._message__item_120ku_1 {
  display: flex;
  justify-content: end;
  padding-bottom: 10px; }
  ._message__item_assistant_120ku_5 {
    justify-content: start; }
    ._message__item_assistant_120ku_5 > * {
      width: 100%; }
